import React, { useState } from 'react';
import { KeyRound, Copy, Check } from 'lucide-react';
import { getProviderManagerSSOSettings } from '../../../../services/staffingService';

const SSO = ({ customerCompanyId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      const response = await getProviderManagerSSOSettings(customerCompanyId);
      await navigator.clipboard.writeText(response.data.link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // non-fatal
    }
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 max-w-lg">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#404880]/10">
          <KeyRound size={16} className="text-[#404880]" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-900">SSO Integration</h3>
          <p className="text-xs text-gray-500">Share the link with your IT Admin to set up Single Sign-On.</p>
        </div>
      </div>
      <button
        onClick={handleCopy}
        className="flex items-center gap-2 rounded-lg border border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
      >
        {copied ? <Check size={14} className="text-emerald-500" /> : <Copy size={14} />}
        {copied ? 'Link copied!' : 'Copy SSO setup link'}
      </button>
    </div>
  );
};

export default SSO;
